import styled from '@emotion/styled'

export const OrganizationPageContainerStyled = styled.div`
  width: 100%;
`
